import React, { Component } from "react";
import axios from 'axios';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// @mui/material
import { CardContent, Button, Typography, useScrollTrigger } from "@mui/material";

// core components
import Card from "../../components/Card/Card.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import { baseUrl } from '../../components/shared/baseUrl';
import stock1 from '/assets/images/stock-photos/stock-1.jpg';
import stock2 from '/assets/images/stock-photos/stock-3.jpg';
import AboutComponent from "../../components/layouts/AboutComponent.jsx"
import withRouterCompat from "../../actions/routerWrapper";



const levelmod = [
  {
    value: 'ALL',
    label: 'ALL'
  },
  {
      value: '1',
      label: '1(Demonstrated)'
  },
  {
      value: '2',
      label: '2(Structured)'
  },
  {
      value: '3',
      label: '3(Guided)'
  },
  {
      value: '4',
      label: '4(Self-Directed)'
  }

]

const standard = [
  {
    value: 'ALL',
    label: 'ALL'
  },
  {
      value: 'VI',
      label: 'VI'
  },
  {
      value: 'VII',
      label: 'VII'
  },
  {
      value: 'VIII',
      label: 'VIII'
  },
  {
      value: 'IX',
      label: 'IX'
  },
  {
      value: 'X',
      label: 'X'
  },
  {
      value: 'XI',
      label: 'XI'
  },
  {
      value: 'XII',
      label: 'XII'
  }

]

const subject = [
  {
    value: 'ALL',
    label: 'ALL'
},
  {
      value: 'Physics',
      label: 'Physics'
  },
  {
      value: 'Chemistry',
      label: 'Chemistry'
  },
  {
      value: 'Biology',
      label: 'Biology'
  },
  {
      value: 'Mathematics',
      label: 'Mathematics'
  }

]





class Home extends Component {
  constructor(props){
    super(props);
    this.state = {
        userstate:{ id:'', token:''},
        subject :'ALL',
        std:'ALL',
        level:'ALL',
        modu:[],
        mymodu:[],
        module:[],
        kg:[],
        isLoading:true,
        clas:[],
        
    };
    this.handlesubjectChange = this.handlesubjectChange.bind(this);
    this.handlestdChange = this.handlestdChange.bind(this);
    this.handlelevelChange = this.handlelevelChange.bind(this);
    this.handleClickCreate = this.handleClickCreate.bind(this);


  }


  CancelToken = axios.CancelToken;
  source = this.CancelToken.source();

  abortController = new AbortController();

  fetchModule = async () => {
    try{
    let result = await axios.get(`${baseUrl}modules`,{
    cancelToken:this.source.token});
    return result;
    
    }catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
        throw new Error("Cancelled");
      }
    }
  
  };

  fetchKG = async () => {
    try{
      console.log('fetchKg called')
      console.log(this.props.user.email)
    let result = await axios.get(`${baseUrl}generate-kg/upload-kg/${this.props.user.email}`);
    return result;
    
    }catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
        throw new Error("Cancelled");
      }
    }
  
  };



  fetchClass = async () => {

    try{
      let result = await axios.get(`${baseUrl}class`,{
      cancelToken:this.source.token});
      return result;
      
      }catch (error) {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
          throw new Error("Cancelled");
        }
      }

  };

  componentDidMount = () =>{


    console.log(this.props.user);
    this.setState({
      userstate : this.props.user
    })
    
    const { location, navigate } = this.props;


    this.fetchClass()
    .then((response) => {
      const dat = Array.from(response.data)
      //console.log(dat)
      this.setState({clas:dat})        
      })
      .catch((error)=>{
        console.log(error);
      });

    this.fetchKG()
    .then((response) => {
      console.log(response.data)
      //const dat = Array.from(response.data)
      
     this.setState({ kg: response.data.goals }, () => {
        console.log("Updated kg:", this.state.kg);
     });
    
    })
    this.fetchModule()
    .then((response) => {
      console.log(response.data)
      this.setState({
          modu:Array.from(response.data),
          mymodu:Array.from(response.data),
          module:Array.from(response.data),
          isLoading:!this.state.isLoading 
      })    

  })
  .catch((error)=>{
  console.log(error);
  });
       

} 

componentWillUnmount() {
  this.source.cancel("Operation canceled by the user.");
}
  

  ///////////////////////////functions for filter module//////////////////////////////////////////////////////
  handlelevelChange(event){
    if(event.target.value!=='ALL'){

      if(this.state.std!=='ALL'&& this.state.subject!=='ALL'){
        this.setState({
          level:event.target.value,
          modu:this.state.module.filter((module) => module.std === this.state.std && module.level === event.target.value
          && module.subject ===this.state.subject)
  
        })

      }
      else if(this.state.std==='ALL' && this.state.subject!=='ALL') {
        this.setState({
          level:event.target.value,
          modu:this.state.module.filter((module) => module.subject ===this.state.subject && 
          module.level === event.target.value)
        })
      }
      else if(this.state.std!=='ALL' && this.state.subject==='ALL') {
        this.setState({
          level:event.target.value,
          modu:this.state.module.filter((module) => module.std === this.state.std
          && module.level === event.target.value)
        })
      }
      else{
        this.setState({
        level:event.target.value,
        modu:this.state.module.filter((module) => module.level === event.target.value)

    })
  }
  }
  else {
    if(this.state.std!=='ALL'&& this.state.subject!=='ALL'){
      this.setState({
        level:event.target.value,
        modu:this.state.module.filter((module) => module.std === this.state.std
        && module.subject ===this.state.subject)

      })

    }
    else if(this.state.std==='ALL' && this.state.subject!=='ALL') {
      this.setState({
        level:event.target.value,
        modu:this.state.module.filter((module) => module.subject ===this.state.subject)
      })
    }
    else if(this.state.std!=='ALL' && this.state.subject==='ALL') {
      this.setState({
        level:event.target.value,
        modu:this.state.module.filter((module) => module.std === this.state.std)
      })
    }
    
    else{
      this.setState({
        level:event.target.value,
        modu:this.state.module
      })

    }
     
    }
  };



  handlesubjectChange(event){
    if(event.target.value!=='ALL'){

      if(this.state.std!=='ALL'&& this.state.level!=='ALL'){
        this.setState({
          subject:event.target.value,
          modu:this.state.module.filter((module) => module.std === this.state.std && module.subject === event.target.value
          && module.level ===this.state.level)
        })
      }
      else if(this.state.std==='ALL' && this.state.level!=='ALL') {
        this.setState({
          subject:event.target.value,
          modu:this.state.module.filter((module) => module.level ===this.state.level && 
          module.subject === event.target.value)
        })
      }
      else if(this.state.std!=='ALL' && this.state.level==='ALL') {
        this.setState({
          std:event.target.value,
          modu:this.state.module.filter((module) => module.std === this.state.std
          && module.subject === event.target.value)
        })
      }
      else{
      this.setState({
      subject:event.target.value,
      modu:this.state.module.filter((module) => module.subject === event.target.value)

    })
  }
  }
  else {
    if(this.state.std!=='ALL'&& this.state.level!=='ALL'){
      this.setState({
        subject:event.target.value,
        modu:this.state.module.filter((module) => module.std === this.state.std
        && module.level ===this.state.level)

      })

    }
    else if(this.state.std==='ALL' && this.state.level!=='ALL') {
      this.setState({
        subject:event.target.value,
        modu:this.state.module.filter((module) => module.level ===this.state.level)
      })
    }
    else if(this.state.std!=='ALL' && this.state.level==='ALL') {
      this.setState({
        std:event.target.value,
        modu:this.state.module.filter((module) => module.std === this.state.std)
      })
    } 
    else{
      this.setState({
        subject:event.target.value,
        modu:this.state.module
      })

    }
     
    }
  };


  handlestdChange(event){
    if(event.target.value !== 'ALL'){
      if(this.state.subject!=='ALL' && this.state.level!=='ALL'){
        this.setState({
          std:event.target.value,
          modu:this.state.module.filter((module) => module.subject === this.state.subject
          && module.level ===this.state.level && module.std === event.target.value)
        })

      }
      else if(this.state.subject==='ALL' && this.state.level!=='ALL') {
        this.setState({
          std:event.target.value,
          modu:this.state.module.filter((module) => module.level ===this.state.level && 
          module.std === event.target.value)
        })
      }
      else if(this.state.subject!=='ALL' && this.state.level==='ALL') {
        this.setState({
          std:event.target.value,
          modu:this.state.module.filter((module) => module.subject === this.state.subject
          && module.std === event.target.value)
        })
      }
      else{

      this.setState({
        std:event.target.value,
        modu:this.state.module.filter((module) => module.std === event.target.value)

      })
    }
  }else {
    if(this.state.subject!=='ALL' && this.state.level!=='ALL'){
      this.setState({
        std:event.target.value,
        modu:this.state.module.filter((module) => module.subject === this.state.subject 
        && module.level ===this.state.level)     
       })
    }
    else if(this.state.subject==='ALL' && this.state.level!=='ALL') {
      this.setState({
        std:event.target.value,
        modu:this.state.module.filter((module) => module.level ===this.state.level)
      })
    }
    else if(this.state.subject!=='ALL' && this.state.level==='ALL') {
      this.setState({
        std:event.target.value,
        modu:this.state.module.filter((module) => module.subject === this.state.subject)
      })
    }
    else{
      this.setState({
        std:event.target.value,
        modu:this.state.module     
       })
      }
    }  
  };

  
  handleClickCreate = () =>{
    console.log("create click")
    this.props.navigate('/admin/createkg');
    
  }


///////////////////////////////end of filter functions////////////////////////////////////////////////////////////////////


render(){
  const { clas } = this.props || {};
  
  //const { router, params, location, routes } = this.props

  //this.props.setUser()

  //console.log(location);
  //console.log(this.state.modu);
const classe = [];
  
  console.log('User is:'+ this.state.userstate.id);
  console.log('kg is:'+this.state.kg)
 const menu=this.state.kg.map((item, index) => {
          return (
                  
                                                <GridItem xs={12} sm={6} md={3}>
                                                  <Link to={`/admin/createkg/${item._id.split("/").pop()}`}>
                                                    <Card>
                                                        <CardContent>
                                                            <img alt="..." className="card-img-top" src={stock2} />
                                                            <Typography gutterBottom variant="h6" component="p">
                                                               My Activity {index+1}
                                                            </Typography>
                                                            <Typography component="h5" variant="caption">
                                                                Last Edited: {Date(item.updatedAt)} 
                                                                
                                                            </Typography>
                                                            <Typography component="p" variant="caption">
                                                                Description: {item.question}
                                                            </Typography>
                                                        </CardContent>
                                                        {/* <div className="card-body text-center">
                                                            <Button
                                                                onClick={this.handleKgEdit}
                                                                size="small"
                                                                variant="outlined"
                                                                color="primary"
                                                                className="mt-1">
                                                                View Graph
                                                            </Button>
                                                        </div> */}
                                                    </Card>
                                                  </Link>
                                                </GridItem>
             );
          })
  
  return (
    <div>
               
      
        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="display-4 mb-4 font-weight-bold">
                My Activities
              </p>
              {/* <p className="font-size-lg text-black-100">
                    Helpful Resources
              </p> */}
          </div>
        </div>
        <div>
          <Button
            onClick={this.handleClickCreate}
            size="large"
            variant="outlined"
            color="primary"
            className="mt-1">
             Create Activity
          </Button>
        </div>
                <div className="container-fluid">
                  <GridContainer spacing={4}>
                    {menu}
                  </GridContainer>
                </div>

                <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <h1 className="display-3 mb-4 font-weight-bold">
                   Helpful Resources
              </h1>
          </div>
      </div>
      <div className="mt-4 text-center d-flex flex-row flex-wrap justify-content-center">
                                        <div>
                                            <div className="bg-white card card-box card-box-hover-rise px-2 pt-2 pb-3 m-3"
                                                title="Click below to see video">
                                                <b>Computational Thinking: What Is It? How Is It Used?</b>
                                                <iframe src='https://www.youtube.com/embed/qbnTZCj0ugI'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <div className="bg-white card card-box px-2 pt-2 pb-3 m-3"
                                                title="Click below to see video">
                                                <b>Computational Thinking for Children</b>
                                                <iframe src='https://www.youtube.com/embed/mUXo-S7gzds'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />
                                                {/* <i className="details-helper text-black-50">
                                                    Not yet available
                                                </i> */}
                                            </div>
                                        </div>
                                        <div>
                                            <div className="bg-white card card-box px-2 pt-2 pb-3 m-3 "
                                                title="Click below to see video">
                                                <b>What is Computational Thinking?</b>
                                                <iframe src='https://www.youtube.com/embed/kdngEhA4I00'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />

                                            </div>
                                        </div>
                                        <div>
                                            <div className="card card-box px-2 pt-2 pb-3 m-3"
                                                title="Click below to see video">
                                                <b>Computational Thinking for a Computational World</b>
                                                <iframe src='https://www.youtube.com/embed/-nN6vyxa8lk'
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                />
                                            </div>
                                        </div>
                                      </div>

        <div className="container">
          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
              <p className="display-4 mb-4 font-weight-bold">
                Example Activities
              </p>
              {/* <p className="font-size-lg text-black-100">
                    Helpful Resources
              </p> */}
          </div>
        </div>
        
                                        <div className="container-fluid">
                                          <GridContainer spacing={4}>
                                                <GridItem xs={12} sm={6} md={3}>
                                                    <Card>
                                                        <CardContent>
                                                            <img alt="..." className="card-img-top" src={stock1} />
                                                            <Typography gutterBottom variant="h6" component="p">
                                                                Activity 1
                                                            </Typography>
                                                            <Typography component="h5" variant="caption">
                                                                Level: Easy |
                                                                Language: English |
                                                                Subject:Computer Science |
                                                                Class:VIII
                                                            </Typography>
                                                            <Typography component="p" variant="caption">
                                                                Description: To calculate the count of odd numbers between 0 and n
                                                            </Typography>
                                                        </CardContent>
                                                        <div className="card-body text-center">
                                                            <Button
                                                                size="small"
                                                                variant="outlined"
                                                                color="primary"
                                                                className="mt-1">
                                                                View Details
                                                            </Button>
                                                        </div>
                                                    </Card>
                                                </GridItem>
                                            </GridContainer>   
                                        </div>
                                        <div className="container">
                                          <div className="px-0 col-lg-8 col-md-10 col-sm-12 mx-auto text-center">
                                              <h2 className="display-4 mb-4 font-weight-bold">
                                                About Us
                                              </h2>
                                          </div>
                                          <AboutComponent />
                                        </div>
      
             
    </div>
  );
    
  }
}


const mapStateToProps = (state) => {
  //console.log(state)
  return {
  user: state.user
  }
};

const mapDipatchToProps = (dispatch) => {
  return {
    getValues(){
      console.log('setting user...', '$$$$')
      dispatch({type:"GET_VALUES"})
    }
  }
};



export default connect(
  mapStateToProps,
  mapDipatchToProps
)(withRouterCompat(Home));
